import React from "react";
import { CurrencyFormat } from "views/helpers/CurrencyFormat";

export const laporanJurnalTable = () => {
  return [
    {
      title: "No",
      render: (rowData) => {
        return (
          rowData.debet === null &&
          rowData.kredit === null && <span>{rowData.number}</span>
        );
      },
    },
    {
      title: "Nomor Transaksi",
      render: (rowData) => {
        return rowData.debet === null && rowData.kredit === null ? (
          <span className="font-bold">{rowData.nomor_transaksi}</span>
        ) : (
          <span className="indent-4">{rowData.nomor_transaksi}</span>
        );
      },
    },
    {
      title: "Tanggal Transaksi",
      render: (rowData) => {
        return rowData.debet === null && rowData.kredit === null ? (
          <span className="font-bold">{rowData.tanggal_transaksi}</span>
        ) : (
          <span className="indent-4">{rowData.tanggal_transaksi}</span>
        );
      },
    },
    {
      title: "Nama Anggaran",
      render: (rowData) => {
        return rowData.debet === null && rowData.kredit === null ? (
          <span className="font-bold">{rowData.nama_anggaran}</span>
        ) : (
          <span className="indent-4">{rowData.nama_anggaran}</span>
        );
      },
    },
    {
      title: "Debet",
      render: (rowData) => {
        return (
          <span>
            {rowData.debet !== null ? CurrencyFormat(rowData.debet) : ""}
          </span>
        );
      },
    },
    {
      title: "Kredit",
      render: (rowData) => {
        return (
          <span>
            {rowData.kredit !== null ? CurrencyFormat(rowData.kredit) : ""}
          </span>
        );
      },
    },
  ];
};
